var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9823 3.26473C12.631 2.99148 12.4553 2.85485 12.2613 2.80233C12.0902 2.75599 11.9098 2.75599 11.7387 2.80233C11.5447 2.85485 11.369 2.99148 11.0177 3.26473L4.23539 8.53986C3.78202 8.89248 3.55534 9.06879 3.39203 9.28959C3.24737 9.48518 3.1396 9.70552 3.07403 9.93978C3 10.2043 3 10.4914 3 11.0658V18.3007C3 19.4208 3 19.9809 3.21799 20.4087C3.40973 20.785 3.71569 21.091 4.09202 21.2827C4.51984 21.5007 5.0799 21.5007 6.2 21.5007H8.2C8.48003 21.5007 8.62004 21.5007 8.727 21.4462C8.82108 21.3983 8.89757 21.3218 8.9455 21.2277C9 21.1208 9 20.9807 9 20.7007V14.1007C9 13.5407 9 13.2606 9.10899 13.0467C9.20487 12.8586 9.35785 12.7056 9.54601 12.6097C9.75992 12.5007 10.0399 12.5007 10.6 12.5007H13.4C13.9601 12.5007 14.2401 12.5007 14.454 12.6097C14.6422 12.7056 14.7951 12.8586 14.891 13.0467C15 13.2606 15 13.5407 15 14.1007V20.7007C15 20.9807 15 21.1208 15.0545 21.2277C15.1024 21.3218 15.1789 21.3983 15.273 21.4462C15.38 21.5007 15.52 21.5007 15.8 21.5007H17.8C18.9201 21.5007 19.4802 21.5007 19.908 21.2827C20.2843 21.091 20.5903 20.785 20.782 20.4087C21 19.9809 21 19.4208 21 18.3007V11.0658C21 10.4914 21 10.2043 20.926 9.93978C20.8604 9.70552 20.7526 9.48518 20.608 9.28959C20.4447 9.06879 20.218 8.89248 19.7646 8.53986L12.9823 3.26473Z",
    stroke: "#A459FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome05);
export default __webpack_public_path__ + "static/media/home-05.79ed05fdf9d13822a4c5fe49528db9b1.svg";
export { ForwardRef as ReactComponent };